import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import { api } from "../../../services/api/api.service";
import { API_DARTS_ACTIVE_GAME_SCORE_SHOOTOUT } from "../../../services/api/api.urls";
import {toastr} from "react-redux-toastr";
import {I9ShotsActiveGameScoreReducer} from "./types";
import { IActiveTournamentGameData } from "../activeGameScore/toolkit/types";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";

const initialState: I9ShotsActiveGameScoreReducer = {
    activeGameData: {} as IActiveTournamentGameData,
}

export const getShootOutActiveGameScoreData = createAsyncThunk<IActiveTournamentGameData, number, { rejectValue: string }>(
    'shootOutactiveGameScore/get',
    async (gameId, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_ACTIVE_GAME_SCORE_SHOOTOUT}/${gameId}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Shoot out active game score failed.");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const shootOutActiveGameScoreSlice = createSlice({
    name: 'activeGameScore',
    reducers: {
        shootOutSetGameData: (state, action: PayloadAction<IActiveTournamentGameData>) => {
            state.activeGameData = action.payload;
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getShootOutActiveGameScoreData.fulfilled, (state: I9ShotsActiveGameScoreReducer, action) => {
                state.activeGameData = action.payload;
            })
    }
})
export const {shootOutSetGameData} = shootOutActiveGameScoreSlice.actions;
export default shootOutActiveGameScoreSlice.reducer;
